<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-4">
            <h2>View Ticket Details</h2>
            <p>Review Ticket details raised by the user</p>
        </div>
    </div>
</div>
<div class="ticketRaised" *ngIf="ticketDetail">
    
        <h4 class="ticketDtl">Ticket raised by</h4>
    
    <div class="ticketBody mt-5">
        <div class="formAreaAdmin">
            <div class="row m-0">
                <div class="col 6">
                    <div class="ticketProfile">
                     <i> 
                        <img class="icon" src="assets/images/admin/Group3474.png" />
                     </i> 
                    <div class="ticketContent">
                        <b>{{ticketDetail.first_name}} {{ticketDetail.last_name}}
                            <small>Created on {{ticketDetail.created_dttm | date:'d MMM, y'}}</small></b>
                    </div>
                </div>
                </div>
                <div class="col 6">
                    <p class="ticketEmailWrap"> 
                        <span><img class="icon"
                                src="assets/images/admin/mail.png" /></span>
                                <span>{{ticketDetail.email}}</span>
                        <span><img class="icon" src="assets/images/icons/phone.png" /></span>
                        <span>+91 {{ticketDetail.phone}}</span>
                    </p>

                </div>
            </div>
        </div>
    </div>

</div>
<br>
<div class="ticketRaised" *ngIf="ticketDetail">
    <div class="ticketDtl">
        <h4>TICKET DETAILS</h4>
    </div>
    <div class="ticketBody mt-5">
        <div class="row m-0">
        <div class="col-md-8">
        <span class="ticketSubHead">TICKET RAISED ON:</span>
        <div class="ticketSubHeadDtl">
        <span> {{ticketDetail.created_dttm | date:'shortTime'}} &nbsp; <span> |</span> &nbsp;{{ticketDetail.created_dttm | date:'d MMM, y'}}</span>
    </div>
    </div>
    <div class="col-md-4">
        <span class="ticketSubHead">TICKET STATUS:</span>
        <div class="ticketSubHeadStatus">
            <span *ngIf="ticketDetail.status==1">New</span>
            <span *ngIf="ticketDetail.status==2">Resolved</span>
            <span *ngIf="ticketDetail.status==3">Viewed</span>
        </div>
    </div>
    </div>
  </div>
    <div class="ticketBody mt-5">
        <h5>MESSAGE:</h5>
        <p>
            {{ticketDetail.message}}
        </p>
        <br>
    </div>
</div>
<br>
<div class="d-flex w-100 align-items-center justify-content-center mt-3">
    <a href="javascript:void(0);" class="backPage ml-2 mr-2" [routerLink]="['/manage-tickets']">BACK</a>
    <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="markResolved(2)" *ngIf="ticketDetail?.status !=2">MARK RESOLVED</a>
    <!-- <a href="javascript:void(0);" style="pointer-events: none;" class="btn btn-primary btn-sm ml-2 mr-2" *ngIf="ticketDetail.status==2">MARK RESOLVED</a> -->
</div>
<input type="hidden" (click)="open(update)" id="successMsg">
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Ticket Status </h6>
                <p class="size18">Tickect has been resolved successfully.</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>